import React from 'react';
import { makeCSS } from '../../utils/makeCSS';
import { Icon } from './Icon';
import { cx } from '@emotion/css';
import { SizeVariants } from '../../theme/themes';
import { isMobile } from 'react-device-detect';
import { Typography } from './Typography';

/**
 * The CommentBadge is used to indicate the amount of comments
 * that an asset in the AssetTile has.
 */
interface Props {
  /**Amount of comments */
  count?: number;
  /**Selected state to highlights the design of the CommentBadge when an AssetTile is selected.*/
  selected?: boolean; //should be true when AssetTile is selected
}
const useCSS = makeCSS(({ theme }) => {
  return {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: isMobile ? theme.spacing[11] : 38,
      height: isMobile ? theme.spacing[8] : theme.spacing[5],
      padding: theme.spacing[1],
      paddingLeft: theme.spacing[2],
      paddingRight: theme.spacing[2],
      borderRadius: theme.borderRadius.md,
      justifySelf: 'flex-end',
      border: `1px solid ${theme.color.line['03']}`,
      background: `linear-gradient(0deg, ${theme.color.overlay['01']} 0%,  ${theme.color.overlay['01']} 100%), ${theme.color.background.neutral};`,
      fontSize: theme.fontSize[1], // will not be needed when Typography is updated
      fontWeight: theme.fontWeights.regular, // will not be needed when Typography is updated
      color: theme.color.text['02'] // will not be needed when Typography is updated
    },
    selected_style: {
      color: theme.color.text['01'], // will not be needed when Typography is updated
      background: theme.color.overlay.focused
    },

    icon: {
      marginLeft: theme.spacing[2]
    }
  };
});

export const CommentBadge = ({ count, selected }: Props) => {
  const classes = useCSS({ selected });
  let colorVariant: '01' | '02';
  selected ? (colorVariant = '01') : (colorVariant = '02');

  return (
    <span className={cx(classes.root, selected ? classes.selected_style : '')}>
      <Typography>{count}</Typography>

      <div className={cx(classes.icon)}>
        <Icon
          icon="chat_bubble"
          colorVariant={colorVariant}
          size={isMobile ? SizeVariants.lg : SizeVariants.md}
        />
      </div>
    </span>
  );
};
